import { Icon, TooltipDelay, TooltipHost } from "office-ui-fabric-react";
import React from "react";
import './ThreeStateToggle.css'

export enum ToggleState {
    Off = 0,
    Indeterminate = 1,
    On = 2
}

const states = [
    { key: ToggleState.Off, label: "Off", position: "4px" },
    { key: ToggleState.Indeterminate, icon: "Remove", position: "50%" },
    { key: ToggleState.On, label: "On", icon: "CheckMark", position: "calc(100% - 16px)" },
];

type Props = {
    label: string;
    value: ToggleState;
    tooltipContent: JSX.Element;
    onChange: (newValue: ToggleState) => void;
}

const ThreeStateToggle = (props: Props) => {
    const { label, value, tooltipContent, onChange } = props;
    const [index, setIndex] = React.useState<ToggleState>(value);
    const handleToggle = () => {
        const newValue = (value + 1) % states.length;
        setIndex(newValue);
        onChange(newValue);
    }
  
    return <div className="three-state-toggle-wrapper">
        <div className="three-state-label">
            <div>{label}</div>
            <TooltipHost styles={{ root: { paddingLeft: 5 } }}
                delay={TooltipDelay.zero}
                closeDelay={TooltipDelay.long}
                tooltipProps={{ onRenderContent: () => tooltipContent }}>
                <Icon iconName="Info" className='info' />
            </TooltipHost>
        </div>
        <div className="three-state-toggle">
            <button className={`toggle-container ${index !== 0 ? 'is-enabled' : undefined}`} onClick={handleToggle}>
                <span className="toggle-background"
                    style={{ left: index === 1 ? "calc(50% - 6px)" : states[index].position }}>
                        {states[index].icon && <Icon iconName={states[index].icon} className="thumb-icon" />}
                </span>
            </button>
        </div>
    </div>
}

export default ThreeStateToggle;